/* @flow */
import React from 'react';
import cx from 'classnames';
import { getPropClassesFromInstance } from 'lib/getPropClasses';

import './styles/ImageWrapper.scss';

class ImageWrapper extends React.Component {
  static propTypes = {
    size: React.PropTypes.oneOf(['small', 'xsmall']),
    shape: React.PropTypes.oneOf(['circle']),
  };

  static propClasses = {
    shape: {
      circle: 'ImageWrapper--circle',
    },
    size: {
      small: 'ImageWrapper--small',
      xsmall: 'ImageWrapper--xsmall',
    },
  };

  render() {
    return (
      <div className={cx('ImageWrapper', getPropClassesFromInstance(this), this.props.className)}>
        {this.props.children}
      </div>
    );
  }
}

export default ImageWrapper;



// WEBPACK FOOTER //
// ./src/components/ImageWrapper.jsx